module.exports = __webpack_public_path__ + "img/new_Pawer_Logo.8362cc3d.png";